import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions.ts';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-904. Index + detail only — there is deliberately no add or edit route.
// A defect signature is PRODUCED by the triage sweep from observed evidence; a
// human authoring one would mint a fingerprint that matches nothing. The only
// human write is triage (status/jiraKey), which happens on the detail page and
// is gated on UpdateDefectSignature.
export const DefectSignaturesLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListDefectSignatures) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetDefectSignature) ? (
                        <DetailPage/>
                    ) : (
                        <Navigate to='/dashboard'/>
                    )
                }
            />
        </Routes>
    );
};
